module.exports = __webpack_public_path__ + "static/media/search.ede803f2.svg";